/*
 * @Date: 2025-10-17 15:01:33
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2025-10-17 15:03:33
 */
import { defineAppConfig } from 'ice';
import { defineFrameworkConfig } from '@ice/plugin-icestark/types';
import PageLoading from './components/PageLoading';
import Entry from './entry';
const envCDNMap = {
  dev: 'https://robo-static-dev-obs.momenta.cn',
  qa: 'https://robo-static-qa-obs.momenta.cn',
  online: 'https://robo-static-online-obs.momenta.cn',
}
const pathMap = {
  '/resource/vehicles': '/robo-resource-fe/vehicles.html',
  '/resource/vehicle-teams': '/robo-resource-fe/vehicle-teams.html',
  '/resource/tos-management': '/robo-resource-fe/tos-management.html',
  '/resource/ground-staff': '/robo-resource-fe/ground-staff.html',
  '/resource/operation-plan': '/robo-resource-fe/operation-plan.html',
  '/config/groups': '/robo-resource-fe/groups.html',
  '/config/cancel-reasons': '/robo-platform-dlv-fe/cancel-reasons.html',
  '/odd/point': '/robo-resource-fe/point.html',
  '/odd/point-details': '/robo-resource-fe/point-details.html',
  '/odd/point-create': '/robo-resource-fe/point-create.html',
  '/odd/area': '/robo-resource-fe/area.html',
  '/odd/area/avoidance': '/robo-resource-fe/area/avoidance.html',
  '/odd/d2d': '/robo-resource-fe/d2d.html',
  '/odd/operation-route': '/robo-resource-fe/operation-route.html',
  '/odd/speed-limit-route/config': '/robo-resource-fe/speed-limit-route/config.html',
  '/odd/speed-limit-route/group': '/robo-resource-fe/speed-limit-route/group.html',
  '/odd/speed-limit-route/export': '/robo-resource-fe/speed-limit-route/export.html',
  '/order/dispatch-categories': '/robo-order-fe/dispatch-categories.html',
  '/order/orders': '/robo-order-fe/orders.html',
  '/order/vehicles': '/robo-order-fe/vehicles.html',
  '/order/billing': '/robo-order-fe/billing.html',
  '/operation/pricing-rules': '/robo-platform-dlv-fe/pricing-rules.html',
  '/ticket/tickets': '/robo-ticket-fe/tickets.html',
  '/ticket/anomaly': '/robo-ticket-fe/anomaly.html',
  '/analysis/taxi-monitor': '/robo-order-fe/taxi-monitor.html',
  '/analysis/multi-monitor': '/robo-platform-dlv-fe/multi-monitor.html',
  '/analysis/dlv-trend': '/robo-platform-dlv-fe/dlv-trend.html',
  '/analysis/single-monitor': '/robo-platform-dlv-fe/single-monitor.html',
  '/analysis/vehicle-live': '/robo-platform-dlv-fe/vehicle-live.html',
  '/devops/toscase': '/robo-platform-dlv-fe/toscase.html',
  '/devops/tosseat': '/robo-platform-dlv-fe/tosseat.html',
  '/analysis/taxi-trend': '/robo-platform-dlv-fe/taxi-trend.html',
}


const entryMap = {}
Object.keys(envCDNMap).map(env => {
  entryMap[env] = {};
  Object.keys(pathMap).map((key) => {
    entryMap[env][key] = envCDNMap[env] + pathMap[key];
  });
});


export const icestark = defineFrameworkConfig(() => ({
  layout: Entry,
  getApps: () => {
    const originMapData = entryMap[ENV];
    // resource-management微应用
    // originMapData['/resource/vehicles'] = "/micro/robo-resource-fe/" // /micro/robo-resource-fe/ -> http://localhost:6004/
    // originMapData['/resource/vehicle-teams'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/point'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/area'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/area/avoidance'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/d2d'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/operation-route'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/speed-limit-route/config'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/speed-limit-route/group'] = "/micro/robo-resource-fe/"
    // originMapData['/odd/speed-limit-route/export'] = "/micro/robo-resource-fe/"
    // originMapData['/resource/ground-staff'] = "/micro/robo-resource-fe/"
    // originMapData['/resource/operation-plan'] = "/micro/robo-resource-fe/"
    // originMapData['/resource/tos-management'] = "/micro/robo-resource-fe/"
    // originMapData['/config/groups'] = "/micro/robo-resource-fe/"
    // workOder-management微应用
    // originMapData['/ticket/tickets'] = "http://localhost:6005/"
    // originMapData['/ticket/anomaly'] = "http://localhost:6005/"
    // // dlv-fe微应用
    // originMapData['/analysis/multi-monitor'] = "http://localhost:6002/"
    // originMapData['/analysis/single-monitor'] = "http://localhost:6002/"
    // originMapData['/analysis/taxi-trend'] = "http://localhost:6002/"
    // originMapData['/analysis/dlv-trend'] = "http://localhost:6002/"
    // originMapData['/analysis/vehicle-live'] = "http://localhost:6002/"
    // originMapData['/devops/toscase'] = "http://localhost:6002/"
    // originMapData['/devops/tosseat'] = "http://localhost:6002/"
    // originMapData['/operation/pricing-rules'] = "http://localhost:6002/"
    // originMapData['/config/cancel-reasons'] = "http://localhost:6002/"
    // robo-order-fe微应用 (订单管理)
    // originMapData['/order/dispatch-categories'] = "http://localhost:6003/"
    // originMapData['/order/vehicles'] = "http://localhost:6003/"
    // originMapData['/order/orders'] = "http://localhost:6003/"
    // originMapData['/order/billing'] = "http://localhost:6003/"
    // originMapData['/analysis/taxi-monitor'] = "http://localhost:6003/"

    const taxiAppsData = Object.keys(originMapData).map((key) => {
      return {
        path: "/taxi" + key,
        title: "Robotaxi",
        // loadScriptMode: 'fetch' as const,
        loadScriptMode: 'script' as const,
        entry: originMapData[key] + '?ts=' + Date.now(),
      }
    })

    const dlvAppsData = Object.keys(originMapData).map((key) => {
      return {
        path: "/dlv" + key,
        title: "Robovan",
        // loadScriptMode: 'fetch' as const,
        loadScriptMode: 'script' as const,
        // sandbox: true, // 关闭沙箱，避免与 React Query 等库冲突
        entry: originMapData[key] + '?ts=' + Date.now(),
      }
    })
    return taxiAppsData.concat(dlvAppsData);
  },

  appRouter: {
    LoadingComponent: PageLoading,
  },
}));

export default defineAppConfig(() => ({
  app: {
    rootId: 'app',
  },
}));
